module.exports = __webpack_public_path__ + "img/begin_top.b3c1565c.png";